import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/瀚宇星皇";
import { Soulmark } from "../../core/soulmark";

export class 瀚宇星皇 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(3291, "瀚宇星皇", type.圣灵·自然, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "瀚宇星皇使用技能时有60%的几率触发<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>：将再一次使用当前技能并触发<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>特效（不触发原有特效），且触发<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>时技能强制生效。",
            "瀚宇星皇免疫所有的固定伤害和百分比伤害，且不受能力下降效果影响。",
            "瀚宇星皇在出战背包中时，己方精灵每回合恢复最大体力的1/8，且己方首发精灵3回合内免疫异常状态、不受能力下降效果影响、所有技能先制+1。",
        ]);
        this.技能组 = [
            skill.圣世惩杀,
            skill.瀚空之门,
            skill.命宇轮回,
            skill.亘古圣辰诀,
            skill.万皇宗魄诀,
        ];
    }
}
